import React, { InputHTMLAttributes } from 'react';
import ProductFilters from './ProductFilters';
import { Option } from '~/types/products';
import PlainButton from '~/components/PlainButton';
import ComparePlans from '~/components/Icons/outline/ComparePlans';

interface Props {
  productFilters: {
    addPhoneState: boolean;
    options: Option[];
    setOptions: (options: Option[]) => void;
    sweetener: Option;
    voiceAvailable: boolean;
    handleAddHomePhone: (event: InputHTMLAttributes<HTMLInputElement>) => void;
    setSweetener: (selected: Option) => void;
  };
  options?: {
    phone: string;
    rewards: string;
  };
  setOpenModal: () => void;
  comparisonToolEnabled: boolean;
}

const DefaultFilters: React.FC<Props> = ({ productFilters, setOpenModal, comparisonToolEnabled }) => {
  return (
    <div className="plan-packages__action-bar">
      <div className="filter-container">
        <ProductFilters
          {...productFilters}
          options={productFilters.options.map((option) => {
            const preampLabel = option.value;
            if (preampLabel) option.value = preampLabel;
            return option;
          })}
        />
      </div>
      {comparisonToolEnabled && (
        <PlainButton className="compare-plans-button" onClick={setOpenModal} icon={<ComparePlans />}>
          COMPARE PLANS
        </PlainButton>
      )}
    </div>
  );
};

DefaultFilters.displayName = 'DefaultFilters';

export default DefaultFilters;
